import React, { useEffect, useState } from 'react'
import FWOTextInput from '../../form/FWOTextInput'
import FWOTextAreaInput from '../../form/FWOTextAreaInput'
import FWOPhone from '../../helpers/FWOPhone'
import FWOSelectInput from '../../form/FWOSelectInput'
import FWOLabel from '../../form/FWOLabel'
import FWOLabelHtml from '../../form/FWOLabelHtml'
import FWORadioSelectInput from '../../form/FWORadioSelectInput'
import FWOSuburbPostcodeLookup from '../../helpers/FWOSuburbPostcodeLookup'
import { buildSelectItems } from '../common'

import {
  IInteractiveTemplateField,
  InteractiveTemplateFieldType,
} from '../../../models/InteractiveTemplate'
import FWODateInput from '../../form/FWODateInput'

const FWOIteractiveTemplateRow = (props: IInteractiveTemplateField) => {
  const [options, setOptions] = useState([])

  const type = props.type.toLowerCase()

  useEffect(() => {
    if (
      type === InteractiveTemplateFieldType.Radio ||
      type === InteractiveTemplateFieldType.Select ||
      type === InteractiveTemplateFieldType.Award ||
      type === InteractiveTemplateFieldType.Checkbox
    ) {
      const options = buildSelectItems(props.values)
    
      if (type === InteractiveTemplateFieldType.Award) {
        options.unshift({
          checked: true,
          key: '0',
          parentkey: '',
          text: '[Choose one]',
          value: '',
        })
      }
      setOptions(options)
    }
  }, [])

  const getTooltipIcon = (props) => {
    return props.important ? '!' : props.hint ? '?' : ''
  }

  switch (type) {
    // TEXTAREA
    case InteractiveTemplateFieldType.TextArea:
      return (
        <FWOTextAreaInput
          placeholder={props.placeholder}
          label={props.label}
          name={props.replacement}
          required={props.required}
          rows={4}
          htmlTooltip={props.important ?? props.hint ?? ''}
          defaultHtmlTooltipIconText={getTooltipIcon(props)}
        />
      )

    // INPUT
    case InteractiveTemplateFieldType.Email:
    case InteractiveTemplateFieldType.Text:
      return (
        <FWOTextInput
          type="text"
          placeholder={props.placeholder}
          label={`${props.label} ${props.required ? '' : ' (optional)'}`}
          ariaLabel={props.label}
          name={props.replacement}
          required={props.required}
          htmlTooltip={props.important ?? props.hint ?? ''}
          defaultHtmlTooltipIconText={getTooltipIcon(props)}
        />
      )

    // INSTRUCTION
    case InteractiveTemplateFieldType.Instruction:
      return (
        <p>
          <FWOLabelHtml
            label={props.label}
            name={props.replacement}
            htmlTooltip={props.important ?? props.hint ?? ''}
            defaultHtmlTooltipIconText={getTooltipIcon(props)}
          />
        </p>
      )

    // DATE
    case InteractiveTemplateFieldType.Date:
      return (
        <FWODateInput
          placeholder={props.placeholder}
          label={props.label}
          name={props.replacement}
          htmlTooltip={props.hint}
          defaultHtmlTooltipIconText={getTooltipIcon(props)}
        />

        // <FWOTextInput
        //   type="text"
        //   placeholder="DD/MM/YYYY"
        //   label={`${props.label} ${props.required ? '' : ' (optional)'}`}
        //   ariaLabel={props.label}
        //   name={props.replacement}
        //   required={props.required}
        //   htmlTooltip={props.important ?? props.hint ?? ''}
        //   defaultHtmlTooltipIconText={getTooltipIcon(props)}
        // />
      )
    // AWARD
    case InteractiveTemplateFieldType.Award:
    case InteractiveTemplateFieldType.Select:
      return (
        <FWOSelectInput
          className="interactive-template award"
          placeholder={props.placeholder}
          label={props.label}
          name={props.replacement}
          required={props.required}
          options={options}
          loading={false}
        />
      )
    // PHONE
    case InteractiveTemplateFieldType.Phone:
      return (
        <FWOPhone
          placeholder="eg. (02) 1234 5678 or 0412345678" //{props.placeholder}
          label={props.label}
          name={props.replacement}
          required={props.required}
        />
      )
    // RADIO
    case InteractiveTemplateFieldType.Radio:
      return (
        <FWORadioSelectInput
          options={options}
          label={props.label}
          name={props.replacement}
          required={props.required}
          onSelection={props.onSelection}
          htmlTooltip={props.important ?? props.hint ?? ''}
          defaultHtmlTooltipIconText={getTooltipIcon(props)}
        />
      )
    // CHECKBOX
    case InteractiveTemplateFieldType.Checkbox:
      return (
        <>
          <FWOLabel
            label={props.label}
            name={props.label}
            htmlTooltip={props.hint}
            defaultHtmlTooltipIconText={getTooltipIcon(props)}
          />
          <p>&nbsp;</p>
          {options?.map((option, index) => {
            return (
              <p key={index}>
                <input
                  key={index}
                  type="checkbox"
                  name={`${props.replacement}_${index}`}
                  value={option.value}
                  onChange={(e) => props.onChange(e)}
                />
                {option.text}
              </p>
            )
          })}
        </>
      )

    // ADDRESS
    case InteractiveTemplateFieldType.Address:
      return (
        <>
          <p>
            <FWOLabel
              label={props.label}
              name={props.replacement}
              htmlTooltip={props.important ?? props.hint ?? ''}
              defaultHtmlTooltipIconText={getTooltipIcon(props)}
            />
          </p>

          <FWOTextInput
            type="text"
            placeholder="Street no. and name"
            label="Street no. and name "
            ariaLabel="Street no. and name"
            name={`${props.replacement}_STREET`}
            required={props.required}
          />

          <FWOSuburbPostcodeLookup
            suburbFieldId={`${props.replacement}_SUBURB`}
            postcodeFieldId={`${props.replacement}_POSTCODE`}
            stateFieldId={`${props.replacement}_STATE`}
            suburbLabel="Suburb "
            postcodeLabel="Post code "
            stateLabel="State "
            required={props.required}
            placeholder="Start typing....."
          />
        </>
      )

    default:
      return <></>
  }
}

export default FWOIteractiveTemplateRow
